import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {getReq, postReq, CONFIG} from "../../helpers/api.js";
import { baseApiUrl } from "../../helpers/constants.js";
import { clearStorage, getStorage } from "../../helpers/utility.js";


const initialState = {
    userdata:{},
    jjpi:'',
    uuid:'',
    loading:false,
    isSuccess: false
  };

export const checkLogin = createAsyncThunk(
    "auth/checklogin",
    async (checkLoginPayload, {rejectWithValue}) => {
        try{
            let resp = await postReq(baseApiUrl+'/api/auth/checklogin', checkLoginPayload);
            return resp;
        } catch(error){
            rejectWithValue(error.response.data);
        }
    }
); 
export const doLogin = createAsyncThunk(
  "auth/dologin",
  async (inputObj, {rejectWithValue}) => {
      try{
          let resp = await postReq(baseApiUrl+'/client-project/al-fadly/login', inputObj);
          return resp;
      } catch(error){
          rejectWithValue(error.response.data);
      }
  }
); 

const authSlice = createSlice({
    name: "auth",
    initialState:initialState,
    reducers:{
      doLogout(state, { payload }) {
        clearStorage();
        state = initialState;
      }
    },
    extraReducers: {
      [checkLogin.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [checkLogin.fulfilled]: (state, { payload }) => {
        state.loading = false;
        state.isSuccess = true;
        state.userdata = payload.userdata;
        state.jjpi = payload.jjpi;
        state.uuid = payload.uuid;
      },
      [checkLogin.rejected]: (state, { payload }) => {
        state.loading = false;
        state.isSuccess = false;
      },


      [doLogin.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [doLogin.fulfilled]: (state, { payload }) => {
        state.loading = false;
        state.isSuccess = true;
        state.userdata = payload.userdata;
        state.jjpi = payload.jjpi;
        state.uuid = payload.uuid;
      },
      [doLogin.rejected]: (state, { payload }) => {
        state.loading = false;
        state.isSuccess = false;
      },
    },
  });

  export const { doLogout } = authSlice.actions;
export default authSlice.reducer;